import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "my-3 p-3 bg-app" };
const _hoisted_2 = { class: "dialog-bar text-white d-flex align-items-center mb-3" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", { class: "m-0 nunito fw-bold w-25 fz-18 fz-sm-22 fz-lg-26" }, "Edit Image", -1);
const _hoisted_4 = { class: "w-75 text-end mx-2" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-x" }, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-check-lg fz-24" }, null, -1);
const _hoisted_7 = { class: "dialog-bar text-white d-flex align-items-center my-3 w-25 mx-auto justify-content-center" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", { class: "bi bi-file-earmark-image" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "mdi-rotate-left-variant",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "#ffffff"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M4,2H7A2,2 0 0,1 9,4V20A2,2 0 0,1 7,22H4A2,2 0 0,1 2,20V4A2,2 0 0,1 4,2M20,15A2,2 0 0,1 22,17V20A2,2 0 0,1 20,22H11V15H20M14,4A8,8 0 0,1 22,12L21.94,13H19.92L20,12A6,6 0 0,0 14,6V9L10,5L14,1V4Z" })
], -1);
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "mdi-rotate-right-variant",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "#ffffff"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M10,4V1L14,5L10,9V6A6,6 0 0,0 4,12L4.08,13H2.06L2,12A8,8 0 0,1 10,4M17,2H20A2,2 0 0,1 22,4V20A2,2 0 0,1 20,22H17A2,2 0 0,1 15,20V4A2,2 0 0,1 17,2M4,15H13V22H4A2,2 0 0,1 2,20V17A2,2 0 0,1 4,15Z" })
], -1);
const _hoisted_13 = [
    _hoisted_12
];
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "mdi-axis-z-rotate-clockwise",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "#ffffff"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M14,12L10,16L14,20V16.9C18.56,16.44 22,14.42 22,12C22,9.58 18.56,7.56 14,7.1V9.09C17.45,9.43 20,10.6 20,12C20,13.4 17.45,14.57 14,14.91V12M4,12C4,10.6 6.55,9.43 10,9.09V7.1C5.44,7.56 2,9.58 2,12C2,14.16 4.74,16 8.58,16.7L7.88,16L9.08,14.79C6.11,14.36 4,13.27 4,12M13,2H11V13L13,11V2M13,22V21L11,19V22H13Z" })
], -1);
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "mdi-horizontal-rotate-counterclockwise",
    width: "32",
    height: "32",
    viewBox: "0 0 24 24",
    fill: "#ffffff"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M12 10H9.09C9.43 6.55 10.6 4 12 4S14.57 6.55 14.91 10H16.9C16.44 5.44 14.42 2 12 2S7.56 5.44 7.1 10H4L8 14L12 10M12 20C10.73 20 9.64 17.89 9.21 14.92L8 16.12L7.3 15.42C8 19.26 9.84 22 12 22C14.42 22 16.44 18.56 16.9 14H14.91C14.57 17.45 13.4 20 12 20M22 11H13L11 13H22V11M2 13H5L3 11H2V13" })
], -1);
const _hoisted_17 = [
    _hoisted_16
];
/*
Esto sólo sirve para que el componente tenga el Nombre VueCropper en las debug tools, si no aparece como AnonymousComponent
*/
const __default__ = {
    components: {
        VueCropper,
    },
};
import { useRouter, useRoute } from 'vue-router';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { onMounted, ref, computed } from 'vue';
import { useCalendarImagesStore } from '../stores/calendarImages';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'PhotoEditor',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const calendarImagesStore = useCalendarImagesStore();
        const imageIndex = ref(0);
        const cropper = ref(null);
        const fileInput = ref(null);
        onMounted(() => {
            imageIndex.value = Number(route.params.id);
        });
        function saveChanges() {
            calendarImagesStore.calendarImages[imageIndex.value].cropper.cropped = cropper.value.getCroppedCanvas();
            calendarImagesStore.calendarImages[imageIndex.value].imageFile = imageReplacement;
            calendarImagesStore.imageSelected = true;
            router.back();
        }
        function discardChanges() {
            //calendarImagesStore.calendarImages.value=calendarImagesStore.calendarImages.splice(imageIndex.value,1);
            router.back();
        }
        function scaleX() {
            calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledX = calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledX * -1;
            cropper.value.scaleX(calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledX);
        }
        function scaleY() {
            calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledY = calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledY * -1;
            cropper.value.scaleY(calendarImagesStore.calendarImages[imageIndex.value].cropper.scaledY);
        }
        let imageReplacement = calendarImagesStore.calendarImages[imageIndex.value].imageFile;
        function onFileSelected(e) {
            const fileInputElement = e.target;
            if (fileInputElement.files) {
                cropper.value.replace(URL.createObjectURL(fileInputElement.files[0]));
                imageReplacement = fileInputElement.files[0];
            }
        }
        const sourceFile = computed(() => {
            return URL.createObjectURL(calendarImagesStore.calendarImages[imageIndex.value].imageFile);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close btn-close-white ms-2 me-1",
                            "aria-label": "Close",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).back()))
                        }),
                        _hoisted_3,
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary mx-2",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).back()))
                            }, [
                                _hoisted_5,
                                _createTextVNode("Cancel")
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[2] || (_cache[2] = ($event) => (saveChanges()))
                            }, [
                                _hoisted_6,
                                _createTextVNode(" Save ")
                            ])
                        ])
                    ]),
                    _createVNode(_unref(VueCropper), {
                        class: "cropper",
                        ref_key: "cropper",
                        ref: cropper,
                        src: _unref(sourceFile),
                        "aspect-ratio": 1.537,
                        "view-mode": 2
                    }, null, 8, ["src", "aspect-ratio"]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "photo-editor-button",
                            onClick: _cache[3] || (_cache[3] = ($event) => (fileInput.value?.click()))
                        }, _hoisted_9),
                        _createElementVNode("button", {
                            type: "button",
                            class: "photo-editor-button",
                            onClick: _cache[4] || (_cache[4] = ($event) => (cropper.value.rotate(-90)))
                        }, _hoisted_11),
                        _createElementVNode("button", {
                            type: "button",
                            class: "photo-editor-button",
                            onClick: _cache[5] || (_cache[5] = ($event) => (cropper.value.rotate(90)))
                        }, _hoisted_13),
                        _createElementVNode("button", {
                            type: "button",
                            class: "photo-editor-button",
                            onClick: _cache[6] || (_cache[6] = ($event) => (scaleX()))
                        }, _hoisted_15),
                        _createElementVNode("button", {
                            type: "button",
                            class: "photo-editor-button",
                            onClick: _cache[7] || (_cache[7] = ($event) => (scaleY()))
                        }, _hoisted_17)
                    ])
                ]),
                _createElementVNode("input", {
                    class: "d-none",
                    ref_key: "fileInput",
                    ref: fileInput,
                    accept: "image/*",
                    type: "file",
                    onChange: _cache[8] || (_cache[8] = ($event) => (onFileSelected($event)))
                }, null, 544)
            ], 64));
        };
    }
});
